import { object, string } from 'yup';

export const nominationSchema = object().shape({
    nomineeId: string().uuid().required('Required*'),
    nominationReason: string().required('Required*').min(10, 'Minimum 10 Chracter Required'),
});


